import script from "./NewDevice.vue?vue&type=script&setup=true&lang=js"
export * from "./NewDevice.vue?vue&type=script&setup=true&lang=js"

import "./NewDevice.vue?vue&type=style&index=0&id=9e71bda8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e71bda8"]])

export default __exports__